<template>
  <div @click="fullscreen" style="height:100%">
    <el-carousel ref="carousel" height="100%" style="height: 100%" :autoplay="true" :interval="5000" @mouseenter.native="autoplayHandler">
        <el-carousel-item v-for="(item, index) in carouselList" :key="item.id">
            <CarouselItem :data="item" :itemClass="index % 2 === 0 ? 'two' : 'one'"/>
        </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import CarouselItem from '../components/CarouselItem'

export default {
  components: {
    CarouselItem
  },
  data () {
    return {
      carouselList: []
    }
  },
  mounted () {
    this.carouselList = JSON.parse(localStorage.getItem('carouselData'))
  },
  methods: {
    fullscreen: function () {
      if (document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen()
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen()
        }
      }
    },
    autoplayHandler: function () {
      this.$refs['carousel'].handleMouseEnter = () => {}
    }
  }
}
</script>

<style>
/* .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
} */
</style>
